import DateField from "../../components/DateField";
import { gtmPush } from "../../functions/gtm";
import {
  requestTypes,
} from './CVOConstants';
import { DEFAULT_THEME } from "../../constants";

const StepDate = ({ values, errors, touched, setFieldValue, setFieldTouched, theme = DEFAULT_THEME }) => {
  //
  const labels = {
    [requestTypes.NO_LONGER_OWN]: "Date of sale",
    [requestTypes.NEW_OWNER]: "Date of purchase",
    [requestTypes.WRITTEN_OFF]: "Write-off date",
  };
  const headings = {
    [requestTypes.NO_LONGER_OWN]: "Sale details",
    [requestTypes.NEW_OWNER]: "Purchase details",
    [requestTypes.WRITTEN_OFF]: "Write-off details",
  };
  const gtmNames = {
    [requestTypes.NO_LONGER_OWN]: "cvoDateSold",
    [requestTypes.NEW_OWNER]: "cvoDatePurchased",
    [requestTypes.WRITTEN_OFF]: "cvoDateWrittenOff",
  }

  return (
    <div className="mb-5">
      <p className="aui-headline-4 mb-4">{headings[values.requestType] || "Date of change"}</p>
      <DateField name="dateOfChange"
        label={labels[values.requestType] || "Date"}
        value={values.dateOfChange}
        maxDate={new Date()}
        onChange={(v) => {
          setFieldValue('dateOfChange', v);
          gtmPush(gtmNames[values.requestType], "ChangeVehicleOwnership", v);
        }}
        isInvalid={errors.dateOfChange && touched.dateOfChange}
        invalidMessage={errors.dateOfChange}
        onBlur={() => { setFieldTouched('dateOfChange'); }}
        theme={theme === "dark" ? "light" : null}
      />
    </div>
  );
};

export default StepDate;
